import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const AnalysisTemplateRoutes: RouteBundle = {
  domain: 'analyses',
  routes: [
    {
      urlPattern: ':currentUserUrl/analysis-templates/:analysisTemplateId',
      handler: EditorRoutes.analysisTemplateEditor.bind(EditorRoutes),
    },
  ],
};
